import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { AssetSvg } from "../../../assets";
type Props = {
  handleShow: (value: boolean) => void;
};
export function ShareGuestLinkButton(props:Props) {
  return (
      <button

        className="btn btn-opaque conference-control-btn"
        type="button"
        onClick={() => props.handleShow(true)}
      >
        <AssetSvg.LinkShare /></button>
  );
}
